<template>
  <CContainer fluid>
    <CTabs variant="tabs" :active-tab="0" @update:activeTab="onActiveTab">
      <CTab title="Info">
        <CRow>
          <CCol>
            <CCard>
              <CCardHeader>
                <CRow class="justify-content-between px-3">
                  <b>User info</b>
                  <div class="d-flex">
                    <CButton
                      @click="isShowEditConsumerInfoModal = true"
                      size="sm"
                      color="primary"
                      class="mr-2"
                      >Edit</CButton
                    >
                    <CButton
                      @click="changeStatusModal = true"
                      size="sm"
                      color="warning"
                      class="mr-2"
                      >Change Status</CButton
                    >

                    <CButton
                      size="sm"
                      color="dark"
                      class="mr-2"
                      @click="onFetchNoteInternal"
                      >Internal Notes</CButton
                    >
                  </div>
                </CRow>
              </CCardHeader>
              <CCardBody>
                <CRow>
                  <dd class="col-sm-12">
                    <CImg
                      v-bind:src="user.photo_url || 'img/no-avatar.png'"
                      width="100px"
                      height="100px"
                      class="mb-2"
                      shape="rounded"
                    />
                  </dd>

                  <dt class="col-sm-2">ID</dt>
                  <dd class="col-sm-10">{{ user.id }}</dd>
                  <dt class="col-sm-2">Name</dt>
                  <dd class="col-sm-10">{{ user.name ? user.name : '-' }}</dd>
                  <dt class="col-sm-2">Email</dt>
                  <dd class="col-sm-10">{{ user.email }}</dd>
                  <dt class="col-sm-2">Phone</dt>
                  <dd class="col-sm-10">
                    {{ user.phone_number ? user.phone_number : '-' }}
                  </dd>
                  <dt class="col-sm-2">Role</dt>
                  <dd class="col-sm-10">{{ user.role }}</dd>
                  <dt class="col-sm-2">Status</dt>
                  <dd class="col-sm-10">
                    <CBadge :color="getUserBadge(user.status)">
                      {{ user.status }}
                    </CBadge>
                  </dd>
                  <dt class="col-sm-2">LastLogin</dt>
                  <dd class="col-sm-10">
                    {{ moment(user.last_login).fromNow() }}
                  </dd>
                  <dt class="col-sm-2">Platform</dt>
                  <dd class="col-sm-10">
                    {{ user.platform ? user.platform : '-' }}
                  </dd>

                  <dt class="col-sm-2">CreatedAt</dt>
                  <dd class="col-sm-10">
                    {{ user.created_at | moment(datetimeFormat) }}
                  </dd>
                  <dt class="col-sm-2">ReferralCode</dt>
                  <dd class="col-sm-10">
                    {{ user.referral_code ? user.referral_code : '-' }}
                  </dd>
                  <dt class="col-sm-2">Credit Balance</dt>
                  <dd class="col-sm-10">
                    <span v-if="user?.credit_balance?.total_credit_amount">
                      {{ user.credit_balance.total_credit_amount }}
                    </span>
                    <span v-else>-</span>
                  </dd>
                  <dt class="col-sm-2">Credit ExpiresAt</dt>
                  <dd class="col-sm-10">
                    <span v-if="user?.credit_balance?.expires_at">
                      {{
                        user.credit_balance.expires_at | moment(datetimeFormat)
                      }}
                    </span>
                    <span v-else>-</span>
                  </dd>
                </CRow>
              </CCardBody>
            </CCard>
          </CCol>
        </CRow>
        <CRow>
          <CCol>
            <CCard>
              <CCardHeader>
                <CRow class="justify-content-between px-3">
                  <b>User setting</b>
                </CRow>
              </CCardHeader>
              <CCardBody>
                <CRow>
                  <dt class="col-sm-2">Owner Provider ID</dt>
                  <dd class="col-sm-10">
                    <span
                      v-if="
                        user.user_setting &&
                        user.user_setting?.owner_provider_id
                      "
                    >
                      <CLink
                        :href="'#/sp/' + user.user_setting?.owner_provider_id"
                        target="_blank"
                      >
                        {{ user.user_setting?.owner_provider_id }}
                      </CLink>
                    </span>
                    <span v-else>-</span>
                  </dd>
                  <dt class="col-sm-2">Stripe Customer</dt>
                  <dd class="col-sm-10">
                    <span
                      v-if="
                        user.user_setting &&
                        user.user_setting?.stripe_customer_id
                      "
                    >
                      <CLink
                        :href="
                          env.stripeURL +
                          '/customers/' +
                          user.user_setting?.stripe_customer_id
                        "
                        target="_blank"
                      >
                        {{ user.user_setting?.stripe_customer_id }}
                      </CLink>
                    </span>
                    <span v-else>-</span>
                  </dd>
                  <dt class="col-sm-2">Default location ID</dt>
                  <dd class="col-sm-10">
                    {{ user.user_setting?.default_location_id }}
                  </dd>
                  <dt class="col-sm-2">Default payment method ID</dt>
                  <dd class="col-sm-10">
                    {{ user.user_setting?.default_payment_method }}
                  </dd>
                </CRow>
                <hr />
                <CRow>
                  <dt class="col-sm-2">BadgeCount</dt>
                  <dd class="col-sm-10">
                    {{ this.countInfo?.badge_count }}
                  </dd>
                  <dt class="col-sm-2">HighlightCount</dt>
                  <dd class="col-sm-10">
                    {{ this.countInfo?.highlight_of_booking }}
                  </dd>
                  <dt class="col-sm-2">UnreadRoom</dt>
                  <dd class="col-sm-10">
                    {{ this.countInfo?.unread_room_count }}
                  </dd>
                </CRow>
              </CCardBody>
            </CCard>
          </CCol>
        </CRow>
      </CTab>
      <CTab title="Invoices">
        <CRow>
          <CCol>
            <InvoiceListComponent
              title="Invoices"
              :items="invoices"
              :fields="invoicesFields"
            />
          </CCol>
        </CRow>
      </CTab>
      <CTab title="Credits">
        <CRow>
          <CCol>
            <CCard>
              <CCardHeader>
                <CRow class="justify-content-between align-items-center px-3">
                  <div class="d-flex align-items-center">
                    <b>Credit History</b>
                    <span class="ml-3">
                      Credits:
                      <b>{{
                        creditBalance.total_credit_amount | currency100
                      }}</b>
                    </span>
                    <span
                      v-if="creditBalance.total_credit_amount"
                      class="ml-3"
                    >
                      Credit Balance:
                      <b>{{ creditBalance.total_credit_amount }}</b>
                    </span>
                    <span class="ml-3">
                      Credit ExpiresAt:
                      <b>{{
                        creditBalance.expires_at | moment(datetimeFormat)
                      }}</b>
                    </span>
                  </div>
                  <div class="d-flex align-items-center">
                    <download-csv
                      class="btn btn-default btn-sm mr-2"
                      :data="creditCsvRows"
                      :labels="{
                        type: 'Type',
                        booking_id: 'Booking ID',
                        amount: 'Amount',
                        balance_after: 'Credit Balance',
                        description: 'Description',
                        datetime: 'Date and time',
                      }"
                      :fields="[
                        'type',
                        'booking_id',
                        'amount',
                        'balance_after',
                        'description',
                        'datetime',
                      ]"
                      :name="`Comenow_Consumer_${id || 'Credits'}_Credits.csv`"
                    >
                      <CIcon name="cil-cloud-download" />
                      Download
                    </download-csv>
                    <CButton
                      v-if="canAdjustCredit"
                      size="sm"
                      color="danger"
                      @click="onOpenAdjustCreditModal"
                    >
                      Adjust Credit
                    </CButton>
                  </div>
                </CRow>
              </CCardHeader>
              <CCardBody>
                <CRow class="align-items-end mb-3">
                  <CCol md="3" sm="6" class="mb-2">
                    <label class="d-block">Credit Type</label>
                    <SelectAllTreeselect
                      v-model="creditFilters.creditType"
                      :options="creditTypeFilterOptions"
                      placeholder="Select credit type"
                    />
                  </CCol>
                  <CCol md="3" sm="6" class="mb-2">
                    <label class="d-block">Booking ID</label>
                    <CInput
                      :value="creditFilters.bookingId"
                      placeholder="Search booking ID"
                      @input="
                        (value) =>
                          (creditFilters = {
                            ...creditFilters,
                            bookingId: value,
                          })
                      "
                    />
                  </CCol>
                  <CCol md="4" sm="6" class="mb-2">
                    <label class="d-block">Created At</label>
                    <date-picker
                      v-model="creditFilters.createdAtRange"
                      range
                      format="YYYY-MM-DD"
                      value-type="date"
                      placeholder="Select date range"
                    />
                  </CCol>
                  <CCol md="2" sm="6" class="mb-2 text-right">
                    <CButton
                      color="primary"
                      class="mb-2 mr-2"
                      @click="onApplyCreditFilter"
                      >Apply</CButton
                    >
                    <CButton
                      color="secondary"
                      variant="outline"
                      class="mb-2"
                      @click="onResetCreditFilter"
                      >Reset</CButton
                    >
                  </CCol>
                </CRow>
                <CDataTable
                  :loading="isLoadingCredit"
                  :items="creditTransactions"
                  :fields="creditFields"
                  :items-per-page="creditPagination.limit"
                  :itemsPerPageSelect="false"
                  :pagination="false"
                  striped
                  border
                  sorter
                >
                  <td slot="booking_id" slot-scope="{ item }">
                    <template v-if="item.resolved_booking_id">
                      <CLink :href="'#/bookings/' + item.resolved_booking_id">
                        {{ item.resolved_booking_id }}
                      </CLink>
                    </template>
                    <span v-else>-</span>
                  </td>
                  <td slot="amount" slot-scope="{ item }">
                    {{ item.amount }}
                  </td>
                  <td slot="balance_after" slot-scope="{ item }">
                    {{ item.balance_after }}
                  </td>
                  <td slot="description" slot-scope="{ item }">
                    {{ item.description }}
                  </td>
                  <td slot="created_at" slot-scope="{ item }">
                    {{ item.created_at | moment(datetimeFormat) }}
                  </td>
                </CDataTable>
                <MyPagination
                  :limit="creditPagination.limit"
                  :total="creditPagination.total"
                  :activePage="creditPagination.page"
                  @changePage="onCreditPageChange"
                  @changePageSize="onCreditPageSizeChange"
                />
              </CCardBody>
            </CCard>
          </CCol>
        </CRow>
      </CTab>
    </CTabs>

    <CModal title="Change status" :show.sync="changeStatusModal" size="lg">
      <CCol sm="4">
        <CSelect
          label="Status"
          :value.sync="statusSelected"
          :options="options"
        />
      </CCol>
      <template #footer>
        <CButton @click="changeStatusModal = false" color="secondary"
          >Cancel</CButton
        >
        <CButton @click="onChangeStatus" color="primary">Save</CButton>
      </template>
    </CModal>

    <CModal
      title="Adjust Credit"
      :show.sync="adjustCreditModal"
      size="lg"
      :centered="true"
      :closeOnBackdrop="false"
    >
      <CForm>
        <CCol sm="6">
          <CInput
            label="Target Amount"
            type="number"
            :value.sync="adjustCreditForm.targetAmount"
            placeholder="Enter target amount"
          />
        </CCol>
      </CForm>
      <template #footer>
        <CButton @click="adjustCreditModal = false" color="secondary"
          >Cancel</CButton
        >
        <CButton
          @click="onAdjustCredit"
          color="primary"
          :disabled="adjustCreditLoading"
        >
          <CSpinner :hidden="!adjustCreditLoading" size="sm" />
          Save
        </CButton>
      </template>
    </CModal>

    <EditConsumerInfoModal
      :showModal="isShowEditConsumerInfoModal"
      :consumerData="{ ...user }"
      @close-modal="isShowEditConsumerInfoModal = false"
      @save="onUpdateConsumer"
    />

    <ViewNoteInternalComponent
      title="Notes"
      :isShow="showNoteInternalList"
      :noteData="noteData"
      @close="showNoteInternalList = false"
    />
  </CContainer>
</template>

<script>
import { ACTION_FETCH_USER, ACTION_FETCH_INVOICES } from '@/store/actions.type';
import { UserBadge } from '@/utils/utils';
import UserProxy from '@/proxies/user.proxy';
import ConsumerProxy from '@/proxies/consumer.proxy';

import env from '@/constants/env';
import { Common } from '@/constants';
import EditConsumerInfoModal from '@/components/modals/EditConsumerInfoModal';
import { MUTATION_SET_USER } from '@/store/mutations.type';
import AdminProxy from '@/proxies/admin.proxy';
import ViewNoteInternalComponent from '@/components/ViewNoteInternalComponent';
import InvoiceListComponent from '@/components/InvoiceListComponent';
import MyPagination from '@/components/MyPagination.vue';
import { mapGetters } from 'vuex';
import { buildCreditHistoryQuery } from '@/views/consumers/creditHistoryQuery';
import { buildCreditExportRows } from '@/views/consumers/creditExport';
import { defaultCreditTypes } from '@/views/consumers/creditTypes';
import { canAdjustCredit } from '@/views/consumers/adjustCreditPermission';
import SelectAllTreeselect from '@/components/SelectAllTreeselect.vue';
import {
  validateAdminConsumerUpdatePayload,
  buildAdminConsumerUpdatePayload,
  resolveUpdateConsumerErrorMessage,
} from '@/views/consumers/updateConsumerPayload';

export default {
  name: 'Consumer',
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.usersOpened = from.fullPath.includes('users');
    });
  },
  components: {
    EditConsumerInfoModal,
    ViewNoteInternalComponent,
    InvoiceListComponent,
    MyPagination,
    SelectAllTreeselect,
  },
  data() {
    return {
      isShowEditConsumerInfoModal: false,
      env,
      datetimeFormat: Common.datetimeFormat,
      id: undefined,
      usersOpened: null,
      changeStatusModal: false,
      statusSelected: 'active',
      adjustCreditModal: false,
      adjustCreditLoading: false,
      adjustCreditForm: {
        targetAmount: '',
      },
      options: [
        { value: 'active', label: 'Active' },
        // { value: 'inactive', label: 'Inactive' },
        { value: 'banned', label: 'Banned' },
      ],
      showNoteInternalList: false,
      noteData: {
        notes: [],
        id: undefined,
        type: 'consumer',
      },
      invoicesFields: [
        {
          key: 'invoice_no',
          label: 'InvoiceNo',
        },
        {
          key: 'booking_no',
          label: 'BookingNo',
        },
        {
          key: 'issued_by',
          label: 'IssuedBy',
        },
        {
          key: 'invoice_type',
          label: 'Type',
        },
        {
          key: 'pdf_file',
          label: 'PDF',
        },
        {
          key: 'created_at',
          label: 'CreatedDate',
        },
      ],
      countInfo: {},
      creditTransactions: [],
      creditCsvRows: [],
      creditFields: [
        {
          key: 'credit_type',
          label: 'CreditType',
        },
        {
          key: 'booking_id',
          label: 'BookingID',
        },
        {
          key: 'amount',
          label: 'Credit Amount',
        },
        {
          key: 'balance_after',
          label: 'Credit Balance',
        },
        {
          key: 'description',
          label: 'Description',
        },
        {
          key: 'created_at',
          label: 'CreatedDate',
        },
      ],
      isLoadingCredit: false,
      creditPagination: {
        limit: 10,
        page: 1,
        total: 0,
      },
      creditSort: 'created_at desc',
      creditFilters: {
        creditType: null,
        bookingId: '',
        createdAtRange: [],
      },
      creditTypeOptions: [...defaultCreditTypes],
      totalCredits: 0,
    };
  },
  async mounted() {
    this.id = this.$route.params.id;
    this.noteData.id = this.id;

    this.$store.dispatch(ACTION_FETCH_USER, this.id);
    this.$store.dispatch(ACTION_FETCH_INVOICES, { consumer_id: this.id });

    this.fetchCreditHistory();

    ConsumerProxy.adminGetConsumerCountInfo(this.id).then(({ data }) => {
      this.countInfo = data;
    });
  },
  computed: {
    ...mapGetters({
      user: 'user',
      invoices: 'invoices',
      permissions: 'permissions',
    }),
    canAdjustCredit() {
      return canAdjustCredit(this.permissions);
    },
    creditTypeFilterOptions() {
      return this.creditTypeOptions.map((type) => ({
        id: type,
        label: type,
      }));
    },
    creditBalance() {
      return this.user?.credit_balance || {};
    },
  },
  methods: {
    goBack() {
      this.usersOpened
        ? this.$router.go(-1)
        : this.$router.push({ path: '/users' });
    },
    getUserBadge(status) {
      return UserBadge(status);
    },
    onChangeStatus() {
      const data = { status: this.statusSelected };
      UserProxy.changeStatus(this.id, data).then(() => {
        this.user.status = this.statusSelected;
        this.changeStatusModal = false;
      });
    },
    onOpenAdjustCreditModal() {
      this.adjustCreditForm.targetAmount = '';
      this.adjustCreditModal = true;
    },
    onAdjustCredit() {
      const rawAmount = this.adjustCreditForm.targetAmount;
      if (rawAmount === '' || rawAmount === null || rawAmount === undefined) {
        this.$toast.error('Please enter a target amount');
        return;
      }
      const targetAmount = Number(rawAmount);
      if (Number.isNaN(targetAmount)) {
        this.$toast.error('Please enter a valid target amount');
        return;
      }

      this.adjustCreditLoading = true;
      ConsumerProxy.adminAdjustCredit({
        consumer_id: parseInt(this.id, 10),
        target_amount: targetAmount,
      })
        .then(() => {
          this.$toast.success('Credit adjusted successfully');
          this.adjustCreditModal = false;
          this.adjustCreditForm.targetAmount = '';
          this.fetchCreditHistory({ page: 1 });
          this.$store.dispatch(ACTION_FETCH_USER, this.id);
        })
        .catch(() => {
          this.$toast.error('Failed to adjust credit');
        })
        .finally(() => {
          this.adjustCreditLoading = false;
        });
    },
    fetchCreditHistory(options = {}) {
      if (options.page !== undefined) {
        this.creditPagination.page = options.page;
      }
      if (options.limit !== undefined) {
        this.creditPagination.limit = options.limit;
      }

      const params = buildCreditHistoryQuery({
        pagination: this.creditPagination,
        sort: this.creditSort,
        filters: this.creditFilters,
        availableCreditTypes: this.creditTypeOptions,
      });

      this.isLoadingCredit = true;
      ConsumerProxy.adminGetCreditHistory(this.id, params)
        .then(({ data }) => {
          const payload = data || {};
          const rows = Array.isArray(payload.rows) ? payload.rows : [];
          this.creditTransactions = rows.map((row) => ({
            ...row,
            resolved_booking_id: this.resolveBookingId(row),
          }));
          this.syncCreditExportRows();
          this.updateCreditTypeOptions(rows);
          this.creditPagination = {
            ...this.creditPagination,
            limit: payload.limit || params.limit,
            page: payload.page || params.page,
            total: payload.total_rows || 0,
          };
          if (payload.sort) {
            this.creditSort = payload.sort;
          }
        })
        .catch(() => {
          this.$toast.error('Failed to load credit history');
        })
        .finally(() => {
          this.isLoadingCredit = false;
        });
    },
    onUpdateConsumer(consumerData) {
      const validationMessage =
        validateAdminConsumerUpdatePayload(consumerData);
      if (validationMessage) {
        this.$toast.error(validationMessage);
        return;
      }

      const data = buildAdminConsumerUpdatePayload(consumerData);
      UserProxy.updateUser(this.id, data)
        .then(() => {
          this.isShowEditConsumerInfoModal = false;
          this.$toast.success(`Update consumer  successfully`, {
            duration: 5000,
          });

          this.$store.commit(MUTATION_SET_USER, {
            ...this.user,
            ...data,
          });
        })
        .catch((error) => {
          const message = resolveUpdateConsumerErrorMessage(error);
          if (message) {
            this.$toast.error(message);
          }
        });
    },
    onFetchNoteInternal() {
      let query = { type: this.noteData.type, id: parseInt(this.id) };
      AdminProxy.fetchNoteInternal(query).then(({ data }) => {
        this.showNoteInternalList = true;
        this.noteData.notes = data;
      });
    },
    resolveBookingId(item) {
      if (!item) {
        return null;
      }

      if (item.booking_id) {
        return item.booking_id;
      }

      const metadata = this.parseMetadata(item.metadata);
      if (metadata) {
        if (metadata.booking_id) {
          return metadata.booking_id;
        }
      }
      return null;
    },
    parseMetadata(rawMetadata) {
      if (!rawMetadata) {
        return null;
      }

      if (typeof rawMetadata === 'object') {
        return rawMetadata;
      }

      if (typeof rawMetadata === 'string') {
        try {
          return JSON.parse(rawMetadata);
        } catch (error) {
          console.warn('Unable to parse credit metadata', error);
        }
      }

      return null;
    },
    onActiveTab(index) {
      if (index === 2 && !this.creditTransactions.length) {
        this.fetchCreditHistory();
      }
    },
    onCreditPageChange(page) {
      this.fetchCreditHistory({ page });
    },
    onCreditPageSizeChange(limit) {
      this.fetchCreditHistory({ limit, page: 1 });
    },
    onApplyCreditFilter() {
      this.fetchCreditHistory({ page: 1 });
    },
    onResetCreditFilter() {
      this.creditFilters = {
        creditType: null,
        bookingId: '',
        createdAtRange: [],
      };
      this.fetchCreditHistory({ page: 1 });
    },
    updateCreditTypeOptions(rows) {
      if (!Array.isArray(rows)) {
        return;
      }
      const existing = new Set(this.creditTypeOptions);
      rows.forEach((row) => {
        if (row && row.credit_type) {
          existing.add(row.credit_type);
        }
      });
      this.creditTypeOptions = Array.from(existing).sort();
    },
    syncCreditExportRows() {
      const exportData = buildCreditExportRows(this.creditTransactions);
      this.creditCsvRows = exportData.rows;
      this.totalCredits = exportData.totalCredits;
    },
  },
};
</script>
